import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import index from '@/components/index/index'
import articleDetail from "@/components/article/articleDetail";
import school from "@/components/school/school";
import list from "@/components/list/list";
import signUp from "@/components/signUp/signUp";
import myCenter from "@/components/myCenter/myCenter";
import infoCenter from "@/components/infoCenter";
import updateInfo from "@/components/infoComment/updateInfo";
import startSign from "@/components/infoComment/startSign";
import checkInfo from "@/components/infoComment/checkInfo";
import findingsAudit from "@/components/infoComment/findingsAudit";
import profile from "@/components/infoComment/profile";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {title: '首页'},
    children: [
      {
        path: '/',
        name: 'index',
        component: index,
        meta: {title: '首页'},
      },
      {
        path: 'article',
        name: 'article',
        component: articleDetail,
        meta: {title: '文章详情'},
      },
      {
        path: 'school',
        name: 'school',
        component: school,
        meta: {title: '学校详情'},
      },
      {
        path: 'list',
        name: 'list',
        component: list,
        meta: {title: '文章列表'},
      },
      {
        path: 'user',
        name: 'myCenter',
        component: myCenter,
        meta: {title: '个人中心'},
      }
    ]
  },
  {
    path: '/signup',
    name: 'signup',
    component: signUp,
    meta: {title: '网上报名'},
  },
  {
    path: '/infoCenter',
    name: 'infoCenter',
    component: infoCenter,
    meta: {title: '网上报名'},
    children: [
      {
        path: 'updateInfo',
        name: 'updateInfo',
        component: updateInfo,
        meta: {title: '上传资料'}
      },
      {
        path: 'sign',
        name: 'startSign',
        component: startSign,
        meta: {title: '开始报名'},
      },
      {
        path: 'check',
        name: 'checkInfo',
        component: checkInfo,
        meta: {title: '查看信息'},
      },
      {
        path: 'result',
        name: 'findingsAudit',
        component: findingsAudit,
        meta: {title: '审核结果'},
      },
      {
        path: 'profile',
        name: 'profile',
        component: profile,
        meta: {title: '修改信息'},
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: './',
  meta: {
    keepAlive: true,
  },
  routes
})

export default router
